module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAATlBMVEUAak70KkEgYUzbMEILZ03pLUJ9SUftLEFsTUiHRke9OUTONEPRM0NfUUnENkPxK0FYU0lRVEp1S0iQREa1O0QnYEwoX0yfQEarPUXoLUKfX1wrAAAA80lEQVR42u2ZVw6DMBAFefROern/RfOJIqUA9qyEtHOB0TNYW5w4juM4Ds6tefTFeK/zBCFv9U4Z29DpE6d4glHfOUYxHPSbCAr9JQs0PDUDHZgWUvAKqd9oGLSGTYpawiVaSQEqZgBF6EWZJDpILuESbeSyXNFIeBAJl1QGDgVQcj/VDB9Dui504EEGA4cCSQ0c2SIHflipgeNs4JA73AE4qr3fD/6ez+zBkZnUD/6DGNVzvi/hJUZ9It/v4kEmm/mDn6N4ic1cy8/nuKSz2pfwex82SWW6h7PfJ0Yrinb7XX5PzWVp+XcD/v3DcRzHcfbOC2U2D+gUR+JqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Bangladesh.png
// module id = 560
// module chunks = 0